<div class="text-7xl" i18n>News</div>

<button mat-fab
  *renderIf="{ roles: [UserRolesEnum.admin, UserRolesEnum.stand_admin] }"
  color="accent"
  class="!absolute top-0 right-[-10px] z-10"
  (click)="addNews()"
  aria-label="Add News">
  <mat-icon svgIcon="core:add"></mat-icon>
</button>

<paged-virtual-scroller
  [scrollWithMainScrollbar]="true"
  [itemTpl]="newsScrollerTpl"
  [itemHeight]="290"
  [itemWidth]="315"
  [pageSize]="16"
  [scaleUpOnRender]="true"
  [itemsQuery]="newsQuery"
  [renderOnTimeOut]="0">
</paged-virtual-scroller>

<ng-template let-item let-index="index" #newsScrollerTpl>
  <news-block
    class="w-[290px] h-[275px]"
    #newsBlock
    [newsItem]="item"
    [itemIndex]="index"
    [imageSizes]="[{w: 298, h: 168, resizeMode: 'fill'}]"
    itemListId="stand_news_list"
    [itemListName]="company.slug + '_news_list'">
    <card-edit-bar
    *renderIf="{roles:[UserRolesEnum.admin, UserRolesEnum.stand_admin]}"
    [show]="newsBlock.hovered"
    (edit)="editNews(item)"
    (softDelete)="deleteNews(item)"
    [disableDelete]="item?.newsStatus.includes(newsStatusEnum.portalLevelValidated)"
    i18n-editTooltip  editTooltip="edit news item"
    i18n-deleteTooltip  deleteTooltip="delete news item"
    i18n-deleteMsg deleteMsg="Do you really want to delete this news item?">
  </card-edit-bar>
  </news-block>
</ng-template>
